import { logWrapper } from '../utils';
import jQuery from 'jquery';

function pwCheckDirectiveFactory(runtimeConstant, $timeout) {
  function run() {
    return {
      require: 'ngModel',
      link: function (scope, elem, attrs, ctrl) {

        $timeout(() => {
          if (!window.jQuery) {
            return;
          }

          const firstPasswordSelector = `#${attrs.pwCheck}`;
          const firstPasswordElem = jQuery(firstPasswordSelector);

          elem.add(firstPasswordElem).on('keyup', function () {
            scope.$apply(function () {
              const passwordsMatch = elem.val() === firstPasswordElem.val();
              ctrl.$setValidity('pwmatch', passwordsMatch);
            });
          });
        }, 1000);
      },
    };
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const pwCheckDirective = ['runtimeConstant', '$timeout', pwCheckDirectiveFactory];